let config = null;

export default async function getConfig() {
    if (!config && process.env.VS_ENV) {
        config = await import(`../../../configs/${process.env.VS_ENV}.json`);
    }
    return config;
}
